import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09faeb88"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09faeb88')) {
      api.createRecord('09faeb88', component.options)
    } else {
      api.reload('09faeb88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=09faeb88", function () {
      api.rerender('09faeb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RuoYi/Doc/index.vue"
export default component.exports